import { getIsTouchDevice } from '@/utils';
import { useMediaQuery } from '@/hooks';
import RadioGroupField from '@/components/RadioGroupField';
import { Pregunta, PreguntaRespuesta, PreguntasDetalle, SurveyStepsHandler } from '@/hooks/useSurvey';

interface RadioSelectStepProps {
    step: Pregunta;
    details?: PreguntasDetalle[];
    answers: PreguntaRespuesta[];
    handleSurveySteps: SurveyStepsHandler;
    iStep: number;
    finalStep: boolean;
    handleNext: () => void;
}

const RadioSelectStep = ({ step, answers, handleSurveySteps, iStep, handleNext, finalStep }: RadioSelectStepProps) => {
    const isTouchDevice = getIsTouchDevice();
    const xs = useMediaQuery('(min-width: 500px)');

    return (
        <>
            <div
                className={`
                    ${isTouchDevice && xs ? 'flex justify-center' : ''}
                    ${isTouchDevice ? 'pb-10' : 'pb-2.5'}
                `}
            >
                <strong
                    className={`
                        ${isTouchDevice ? (xs ? 'text-[27px]' : 'text-xl') : 'text-lg'}
                        ${isTouchDevice ? 'text-center' : 'text-left'}
                    `}
                >
                    {step.cPregunta}
                </strong>
            </div>

            <RadioGroupField
                value={String(step.nRespuesta)}
                answers={answers}
                setValue={(value) => {
                    handleSurveySteps(iStep, 'nRespuesta', Number(value));
                    if (!finalStep) handleNext();
                }}
            />
        </>
    );
};

export default RadioSelectStep;
